const KEY = "f29_consent";
const SIX_MONTHS = 1000 * 60 * 60 * 24 * 182;

export const getConsent = () => {
  try {
    const c = JSON.parse(localStorage.getItem(KEY));
    return c && Date.now() - c.date < SIX_MONTHS ? c : null;
  } catch {
    return null;
  }
};

export const saveConsent = (audience) => {
  localStorage.setItem(KEY, JSON.stringify({ audience, date: Date.now() }));
  if (audience) window.__f29LoadAnalytics?.();
  else if (window.posthog?.__loaded) window.posthog.opt_out_capturing();
};

export const openCookieSettings = () => window.dispatchEvent(new Event("f29-open-cookies"));
